export function CheckboxSelected() {
  return (
    <g fill="currentColor">
      <path d="M6 0h36c3.313 0 6 2.687 6 6v36c0 3.314-2.687 6-6 6H6c-3.313 0-6-2.686-6-6V6c0-3.313 2.687-6 6-6" />
      <path
        fill="#FFF"
        d="M32.385 15.658c.827-.877 2.168-.877 2.995 0 .827.88.827 2.305 0 3.182l-12.706 13.5c-.827.88-2.168.88-2.995 0l-7.059-7.5c-.827-.877-.827-2.302 0-3.182.827-.877 2.168-.877 2.995 0l5.561 5.911 11.209-11.911z"
      />
    </g>
  )
}
